export default __webpack_public_path__ + "static/media/Taj-ul-Masajid.f6886624.jpg";